"use strict";
var appn;
(function (appn) {
    var views;
    (function (views) {
        var provider;
        (function (provider) {
            var createOrEdit;
            (function (createOrEdit) {
                class InitArgs {
                    constructor() {
                        this.shortDateFormatDefault = appn.emptyString;
                        this.shortTimeFormatDefault = appn.emptyString;
                    }
                }
                let _initArgs;
                function init(args) {
                    _initArgs = args;
                    const shortDateFormat = $('#Provider_ProviderConfig_ShortDateFormat');
                    const shortTimeFormat = $('#Provider_ProviderConfig_ShortTimeFormat');
                    appn.services.validateDateFormat(shortDateFormat.val(), $('#dateFormatResult'));
                    appn.services.validateDateFormat(shortTimeFormat.val(), $('#timeFormatResult'));
                    addEvents(shortDateFormat, shortTimeFormat);
                }
                createOrEdit.init = init;
                function addEvents(shortDateFormat, shortTimeFormat) {
                    shortDateFormat.change(function (event) {
                        if (!shortDateFormat.val())
                            shortDateFormat.val(_initArgs.shortDateFormatDefault);
                        appn.services.validateDateFormat(shortDateFormat.val(), $('#dateFormatResult'));
                    });
                    shortTimeFormat.change(function (event) {
                        if (!shortTimeFormat.val())
                            shortTimeFormat.val(_initArgs.shortTimeFormatDefault);
                        appn.services.validateDateFormat(shortTimeFormat.val(), $('#timeFormatResult'));
                    });
                }
            })(createOrEdit = provider.createOrEdit || (provider.createOrEdit = {}));
        })(provider = views.provider || (views.provider = {}));
    })(views = appn.views || (appn.views = {}));
})(appn || (appn = {}));
